"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactIntl = require("react-intl");
var messages = (0, _reactIntl.defineMessages)({
  formField_DurationPicker_hours: {
    "id": "formField_DurationPicker_hours",
    "defaultMessage": "hours"
  },
  formField_DurationPicker_minutes: {
    "id": "formField_DurationPicker_minutes",
    "defaultMessage": "minutes"
  },
  formValue_select: {
    "id": "formValue_select",
    "defaultMessage": "select"
  }
});
var _default = exports["default"] = messages;
//# sourceMappingURL=messages.js.map